// Área de transferência de nós/edges do diagrama (Ctrl+C/Ctrl+V), compartilhada entre todas as
// abas de circuito — inclusive de clientes diferentes. Guardada em escopo de módulo pelo mesmo
// motivo do catálogo de equipamentos personalizados (ver customEquipmentTypesStore.js): em modo de
// edição, várias abas de circuito ficam montadas ao mesmo tempo, e o usuário pode querer copiar um
// equipamento de um circuito e colar em outro.
//
// Guarda sempre os nós/edges copiados com os ids ORIGINAIS — o remapeamento para ids novos
// acontece a cada colagem (ver pasteClipboard em index.js), o que permite colar o mesmo recorte
// várias vezes (inclusive em diagramas diferentes) sem colidir.
let clipboard = null;

export const setDiagramClipboard = (payload) => {
  clipboard = payload || null;
};

export const getDiagramClipboard = () => clipboard;
